import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { Link } from "react-router-dom";

import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { useLazyLoginDiscordQuery } from '../../../api/index';
import { useSignupMutation } from '../../../api/auth';
import {
	selectLogged,
} from './sessionSlice';
import styles from './Session.module.css';

let googleHrefButton: string;
switch(process.env.NODE_ENV) {
	case "development": {
		//googleHrefButton = "https://bkp.protostructure.com/apidev/auth/google";
		googleHrefButton = "/apidev/auth/google";
		break;
	}
	case "test": {
		googleHrefButton = "/apidev/auth/google";
		break;
	}
	case "production": {
		googleHrefButton = "/api/auth/google";
		break;
	}
	default: {
		googleHrefButton = "/api/auth/google";
		break;
	}
};

export function Login() {
	const session = useAppSelector(selectLogged);
	const dispatch = useAppDispatch();
	const [userNameValue, setUserNameValue] = React.useState('');
	const handleUserNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setUserNameValue(event.target.value);
	};

	const [passwordValue, setPasswordValue] = React.useState('');
	const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPasswordValue(event.target.value);
	};

	// https://redux-toolkit.js.org/rtk-query/usage/mutations#standard-mutation-example
	const [login, result] = useSignupMutation()
	console.log(result.data, result.isLoading);
	const [loginDiscord, resultDiscord] = useLazyLoginDiscordQuery()
	//*
	useEffect(() => {
			  if(resultDiscord && resultDiscord.data) {
				  //setUserData([results.data]);
			  }
			  console.log(resultDiscord)
	},[resultDiscord])
	// */

	//*
	if (result.data)
		return <Navigate to="/" />;
	// */
	const testInputSx = {width: 350};

		return (
			<Container>
				<br /><br />
				<div className={styles.row}>
					Login
				</div>
				<br /><br />
				<Stack sx={{width: '100%'}} spacing={2}>
					<Alert severity="info">New Subscriptions Are Temporarily Unavailable</Alert>
				</Stack>
				<br /><br />
				<div className={styles.row}>
				<TextField
					required
					sx={testInputSx}
					id="outlined-required"
					label="Required"
					defaultValue=""
					onChange={handleUserNameChange}
					disabled={true}
				/>
				</div>
				<div className={styles.row}>
				<TextField
					id="outlined-password-input"
					sx={testInputSx}
					label="Password"
					type="password"
					autoComplete="current-password"
					onChange={handlePasswordChange}
					disabled={true}
				/>
				</div>
				<div className={styles.row}>
				<Button
					variant="outlined"
					disabled={true}
					onClick={() => {
						return (login({
							//user: {
								name: "name",
								email: userNameValue,
								given_name: "name",
								family_name: "name",
								password: passwordValue,
								password_confirmation: "name",
								i18n: "name",
								website: "name",
								location: "",
								description: "description",
							//}
						}))
					}
					}
				>Submit
				</Button>
				</div>
				<div className={styles.row}>
					{/*
					<ul>
						<li>userName: { userNameValue }</li>
						<li>pswd: { passwordValue }</li>
						<li>token: { passwordValue }</li>
					</ul>
					*/}
				</div>
				<div className={styles.row}>
					{/*<a target="_self" href="https://bkp.protostructure.com/apiplay/auth/discord">*/}
						<Button
							variant="outlined"
							disabled={true}
						>Login By Discord/bkp.proto...
						</Button>
					{/*</a>*/}
				</div>
				<div className={styles.row}>
					{/*<a target="_self" href="https://x.xxx.xx.xxx:xxxx/apiplay/auth/discord">*/}
						<Button
							variant="outlined"
							disabled={true}
						>Login By Discord/5.1...
							</Button>
							   {/*</a>*/}
				</div>
				<div className={styles.row}>
					<a
						target="_self"
						href={googleHrefButton}>
						<Button
							variant="outlined"
						>Login By Google/bkp.proto1...
						</Button>
					</a>
				</div>
			</Container>
		);
}
